import { api } from '@/shared/services/api';

export interface Notification {
  id: string;
  type: string;
  title: string;
  body: string;
  priority: 'low' | 'medium' | 'high' | 'critical';
  isRead: boolean;
  data?: Record<string, any>;
  createdAt: string;
}

export interface NotificationPreference {
  type: string;
  label: string;
  description: string;
  email: boolean;
  inApp: boolean;
}

export interface PaginatedResponse<T> {
  data: T[];
  unreadCount: number;
  meta: { total: number; page: number; limit: number; totalPages: number };
}

export const notificationsApi = {
  list: async (params?: Record<string, string>) => {
    const query = params ? '?' + new URLSearchParams(params).toString() : '';
    const res = await api.get<PaginatedResponse<Notification & { readAt?: string | null }>>('/notifications' + query);
    // BUG istoric: API-ul intoarce `readAt` (randul Prisma), tipul frontend asteapta
    // `isRead` — fara mapare, isRead era MEREU undefined → toate notificarile apareau
    // necitite pe veci (punct albastru), desi serverul le stia citite (badge-ul si
    // „Citeste toate" lipseau corect). Mapam aici, la sursa, pentru toate paginile.
    return { ...res, data: res.data.map((n) => ({ ...n, isRead: n.isRead === true || n.readAt != null })) };
  },
  unreadCount: () => api.get<{ count: number }>('/notifications/unread-count'),
  markAsRead: (id: string) => api.patch<Notification>('/notifications/' + id + '/read', {}),
  markAllAsRead: () => api.post<{ message: string }>('/notifications/mark-all-read', {}),
  getPreferences: () => api.get<NotificationPreference[]>('/notification-preferences'),
  updatePreference: (type: string, data: { email?: boolean; inApp?: boolean }) =>
    api.patch<NotificationPreference>('/notification-preferences/' + type, data),
};
